import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";

const Lift15 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g
			id="Lift15"
			className={getLiftClass(isOpen, activeLiftId === '15', state)}
			transform="translate(2134.000000, 910.000000)"
		>
			<path
				className="animated"
				d="M13.5,12.5 L37.6274883,58.2177887 M54.0523144,89.3402464 L94,165.034816 L155.238307,247.112297"
				stroke={colors[0]} strokeWidth="3" strokeLinecap="round" strokeDasharray="6"/>

			<LiftLabelTypeSeat
				seatCount="4"
				colors={getLiftStatusColors(state, isOpen)}
				coords="86.541070, 167.000000"
				isOpen={isOpen}/>

			<g id="Labe-lift" className="lift-label">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(14.547130, 14.547130) scale(-1, 1) rotate(-59.000000) translate(-14.547130, -14.547130) "
				points="9.04712957 14.5471296 20.0471296 9.04712957 17.6756423 14.5471296 20.0471296 20.0471296"/>

			<LabelLift isOpen={isOpen} text={<tspan x="-3" y="13">15</tspan>} coords="149.000000, 243.000000" state={state}/>
		</g>
	);
};


Lift15.propTypes = {};

export default Lift15;
